import { API_BASE } from '../utils/config';
import { apiFetch } from '../utils/apiFetch';
import { WishlistItem } from '../types';

export const getWishlist = async (): Promise<WishlistItem[]> => {
  try {
    const res = await apiFetch(`${API_BASE}/wishlist`);
    if (!res.ok) return [];
    const data = await res.json();
    return data.wishlist || [];
  } catch {
    return [];
  }
};

export const addToWishlist = async (productId: number): Promise<boolean> => {
  try {
    const res = await apiFetch(`${API_BASE}/wishlist`, {
      method: 'POST',
      body: JSON.stringify({ product_id: productId }),
    });
    return res.ok;
  } catch {
    return false;
  }
};

export const removeFromWishlist = async (wishlistId: string): Promise<boolean> => {
  try {
    const res = await apiFetch(`${API_BASE}/wishlist/${wishlistId}`, { method: 'DELETE' });
    return res.ok;
  } catch {
    return false;
  }
};
